import { create } from "zustand";
import { CustomGateway, GatewaysStore } from "./types";
import { fetchGateways } from "./hooks";
import { getStoredCustomGateways, saveCustomGateways } from "./storage";

export const useGatewaysStore = create<GatewaysStore>((set, get) => ({
  gateways: [],
  customGateways: getStoredCustomGateways(),
  isLoading: false,
  error: null,

  load: async () => {
    set({ isLoading: true, error: null });
    try {
      const gateways = await fetchGateways();
      set({ gateways, isLoading: false });
    } catch (error) {
      set({
        isLoading: false,
        error:
          error instanceof Error ? error.message : "Failed to fetch gateways",
      });
    }
  },

  getBySlug: (slug: string) => get().gateways.find((g) => g.slug === slug),

  addCustom: (input) => {
    const gateway: CustomGateway = {
      ...input,
      id:
        typeof crypto !== "undefined" && "randomUUID" in crypto
          ? crypto.randomUUID()
          : `${Date.now()}-${Math.random().toString(36).slice(2)}`,
      custom: true,
    };
    const customGateways = [...get().customGateways, gateway];
    saveCustomGateways(customGateways);
    set({ customGateways });
    return gateway;
  },

  removeCustom: (id: string) => {
    const customGateways = get().customGateways.filter((g) => g.id !== id);
    saveCustomGateways(customGateways);
    set({ customGateways });
  },
}));

/** Kick off gateway discovery once at app start. */
export const initializeGatewaysStore = () => {
  void useGatewaysStore.getState().load();
};
